import {EditBaseCtrl} from "./EditBaseCtrl";
import {Location} from '../../entities/Location'
import { StateService, StateParams } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";
import {EditLocationModel} from "../../models/edit/EditLocationModel";

export class EditLocationCtrl extends EditBaseCtrl<Location>{
    public static $inject = ['$scope','$state','$stateParams','$uibModal','NotificationService','EditLocationModel'];
    locationModel:EditLocationModel;
    constructor($scope:any,
                stateService:StateService,
                stateParamsService:StateParams,
                public modal:angular.ui.bootstrap.IModalService,
                public notifyService:NotificationService,
                model:EditLocationModel) {
        super($scope,stateService,stateParamsService,notifyService,model);
        this.locationModel = model;
        this.loadData().then((ok)=>{
        });
    }
    pagingRoute():string{
        return "admin.locations";
    }
    openPrintDialog():void{
        if(this.model.entity.id == null && (this.model.entity.name == null || this.model.entity.name.length==0))
        {
            alert("Please enter a location name first before printing.");
            return;
        }
        var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.print.html').default,
            controller: 'PrintCtrl',
            size: 'lg',
            resolve: {
                totalCount: function () {
                    return 1;
                },
                templateType: function () {
                    return "Location"
                }
            }
        });
        modalInstance.result.then((printer)=>{
            this.locationModel.print(printer);
        })
    }
}
